import { useState, useRef, useEffect, useLayoutEffect, memo } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";

function UploadImageFile({
    changerEtapeCollecteParticipation,
    participation,
}) {
    let [file, setFile] = useState();
    const fileRef = useRef();
    const [recordingState, setRecordingState] = useState('waiting');

    const uploadFromFile = async (e) => {
        setRecordingState('waiting');
        participation.image = {}
        console.log('uploadFromFile');
        file = e.target.files[0];
        fileRef.current = file;
        if (!file) {
            return;
        }
        participation.image.extension = file.type.split('/')[1];
        participation.image.blob = URL.createObjectURL(file);
        participation.image.file = file;
        setFile(file);
        setRecordingState('finished');
        console.log("finished");
    };
    useLayoutEffect(() => {
        console.log("useEffect");
    }, []);
    return (
        <>
            <Row>
                <Col>
                    <Form.Group controlId="uploadImageFile" className="bouton-charger-image">
                        <Form.Label className="titre-3">Déposez votre image ici</Form.Label>
                        <Form.Control type="file" accept={'image/*'} size="sm" onChange={uploadFromFile} ref={fileRef} />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            {
                // Permet de forcer la mise à jour de l'aperçu
            }
            <p style={{ display: "none" }}>{recordingState}</p>
            {recordingState === 'finished' &&
                <>
                    <Row className="text-center text-16">
                        <Col>
                            Aperçu
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            &nbsp;
                        </Col>
                    </Row>
                    <Row className="text-center apercu-image">
                        <Col>
                            <img width="300" src={URL.createObjectURL(file)} alt="aperçu" />
                        </Col>
                    </Row>
                </>
            }
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row className="custom-commandes">
                <Col>
                    <Button onClick={changerEtapeCollecteParticipation} disabled={recordingState !== 'finished'}>Continuer</Button>
                </Col>
            </Row>

        </>

    )
};
export default memo(UploadImageFile);